import type {ConferenceApiModel} from '../../../api/conference';
import type {Nullable} from '../../utility-types';

export const isConferenceCreatedByClient = (
  conference?: Nullable<ConferenceApiModel>,
) => conference?.created_by === 'client';
